/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useLazyQuery, gql } from '@apollo/client';
import { options } from 'i18next';

export const useSearchSuggestionView = () => {
    const SEARCH_SUGGESTION_GQL = gql`
     query SearchSuggestionView($keyword: String!, $langId: String!) {
        searchSuggestionView(keyword: $keyword, langId: $langId) {
            entry {
            frequency
            term
            }
            identifier
        }
      }`

  const [FetchSuggestionQuery, suggestionDetails] = useLazyQuery(SEARCH_SUGGESTION_GQL,{context:{clientName:"search"}});

  return { FetchSuggestionQuery, suggestionDetails };
};